<script lang="ts">
  import clsx from 'clsx'
  import { cubicOut } from 'svelte/easing'
  import { slide } from 'svelte/transition'
  import videoStore from '../../stores/video.svelte'
  import type { Snippet } from 'svelte'

  type Props = {
    progressBar: Snippet
    controlBar: Snippet
    controlBarMobile?: Snippet
    children?: Snippet
  }

  let { progressBar, controlBar, controlBarMobile, children }: Props = $props()

  let controlBarVisible = $derived(
    (videoStore.showControls() ||
      //!videoStore.state.isPlaying ||
      videoStore.state.settingsMenuOpen) &&
      videoStore.state.hasPlaybackStarted,
  )
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_mouse_events_have_key_events -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
  onclick={(e) => e.stopPropagation()}
  onmouseenter={() => {
    if (!videoStore.state.isMobileLayout) {
      videoStore.forceUserActive()
    }
  }}
  onmouseleave={() => videoStore.forceUserInactive()}
  class={clsx('absolute bottom-0 left-0 flex w-full flex-col', {
    'z-10': !videoStore.state.settingsMenuOpen,
  })}
>
  {@render children?.()}
  {#if videoStore.state.isMobileLayout}
    {#if controlBarMobile && controlBarVisible}
      {@render controlBarMobile()}
      {@render progressBar?.()}{/if}
  {:else if controlBarVisible}
    <div transition:slide={{ duration: 150, axis: 'y', easing: cubicOut }}>
      {@render progressBar?.()}
      {@render controlBar?.()}
    </div>{/if}
</div>
